import * as React from 'react'

const FlagIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.61299 3.64501C3.49053 3.75116 3.39245 3.88251 3.32546 4.03008C3.25847 4.17765 3.22416 4.33795 3.22486 4.50001V20.25C3.22486 20.5484 3.34339 20.8345 3.55437 21.0455C3.76535 21.2565 4.0515 21.375 4.34986 21.375C4.64823 21.375 4.93438 21.2565 5.14536 21.0455C5.35634 20.8345 5.47486 20.5484 5.47486 20.25V16.2863C7.61611 14.6813 9.42174 15.4313 12.1011 16.755C13.6227 17.505 15.358 18.3675 17.2386 18.3675C18.6186 18.3675 20.0774 17.9044 21.5867 16.5975C21.7082 16.4922 21.8058 16.362 21.8727 16.2159C21.9397 16.0697 21.9745 15.9108 21.9749 15.75V4.50001C21.9749 4.28431 21.9129 4.07314 21.7963 3.89166C21.6797 3.71019 21.5134 3.56606 21.3172 3.47645C21.121 3.38684 20.9032 3.35553 20.6897 3.38625C20.4762 3.41696 20.276 3.50841 20.113 3.6497C17.7964 5.65689 15.9383 4.89751 13.0986 3.4922C10.4614 2.18157 7.1783 0.556887 3.61299 3.64501ZM19.7249 15.2119C17.5836 16.8178 15.778 16.0659 13.0986 14.7431C10.9274 13.665 8.3183 12.375 5.47486 13.6753V5.03345C7.61611 3.42845 9.42174 4.17845 12.1011 5.5022C13.6227 6.2522 15.358 7.1147 17.2386 7.1147C18.0971 7.11598 18.9455 6.93011 19.7249 6.57001V15.2119Z"
      fill="currentColor"
    />
  </svg>
)

export default FlagIcon
